<template>
  <div class="row plain-element">
    <div v-if="!isLoggedIn()" class="dashboard-cards">
      <NoPermissionComponent/>
    </div>
    <div v-if="getUsername()" class="dashboard" v-cloak>
      <div class="row row-cards">
        <div class="row text-start row-back">
          <a href="/">
            <span class="material-icons chevron-left">chevron_left</span> Back To Homepage
          </a>
        </div>

        <div class="card card-description">

        <div v-if="getPowerBIDashboards()" class="row plain-element">
            <div class=" col col-12 col-sm-12 col-md-8 col-lg-3 plain-element">
              <div class=" col col-12 col-sm-12 col-md-8 col-lg-11 plain-element">
                <span class="section-header ">Select Site</span>
              </div>
              <div  v-for="(value, key) in getPowerBIDashboards()" class="input-field  col col-12 col-sm-7 col-form" :key="key" :value="value">
                <a @click="setSite(key)">
                  <div v-if="site === key" class="card menu-card menu-card-active">
                    <h5><span class="material-icons chevron-right">chevron_right</span> {{ splitString(key)[0] }} </h5>
                  </div>
                  <div v-else class="card menu-card">
                    <h5><span class="material-icons chevron-right">chevron_right</span> {{ splitString(key)[0] }}</h5>
                  </div>
                </a>
              </div>
            </div>
            <div  v-if="chosen_site !== 'All'" class="col col-12 col-sm-12 col-md-8 col-lg-9 plain-element">
              <div class="row plain-element">
                <div class=" col col-12 col-sm-12 col-md-8 col-lg-8 plain-element">
                  <span class="section-header ">Select Dashboard</span>
                </div>
                <div class=" col col-12 col-sm-12 col-md-8 col-lg-4 plain-element">
                  <span class="section-header ">Energy Tools</span>
                </div>
              </div>
              <div  class="row plain-element">

                <div class=" col col-12 col-sm-12 col-md-8 col-lg-4 plain-element">
                  <div  v-for="(value, key) in getPowerBIDashboards()[chosen_site].slice(0,14)" class="input-field  col col-12 col-sm-9 col-form" :key="key" :value="value">
                    <a @click="gotToPowerBIDashboard(value[1], $event)">
                      <div class="card menu-card">
                        <h5><span class="material-icons chevron-right">chevron_right</span> {{ value[0] }} </h5>
                      </div>
                    </a>
                  </div>
                </div>
                <div class=" col col-12 col-sm-12 col-md-8 col-lg-4 plain-element">
                  <div  v-for="(value, key) in getPowerBIDashboards()[chosen_site].slice(14)" class="input-field  col col-12 col-sm-9 col-form" :key="key" :value="value">
                    <a @click="gotToPowerBIDashboard(value[1], $event)">
                      <div class="card menu-card">
                        <h5><span class="material-icons chevron-right">chevron_right</span> {{ value[0] }} </h5>
                      </div>
                    </a>
                  </div>
                </div>
                <div v-if="getMeterHealthCheckList()" class=" col col-12 col-sm-12 col-md-8 col-lg-4 plain-element">
                  <div v-if="getMeterHealthCheckList()" class="input-field col col-12 col-sm-9 col-form">
                    <a v-if="getMeterHealthCheckList().includes(extractSiteCode(chosen_site))" @click="gotToMeterHealthCheckDashboard(extractSiteCode(chosen_site))">
                      <div class="card menu-card">
                        <h5><span class="material-icons icon-chart">monitor_heart</span> Meter Health Check </h5>
                      </div>
                    </a>
                  </div>
                  <div class="input-field col col-12 col-sm-9 col-form">
                    <a @click="gotToEnergyEyeDashboard(site)">
                      <div class="card menu-card">
                        <h5><span class="material-icons icon-chart">visibility</span> Energy Eye </h5>
                      </div>
                    </a>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { mapGetters, mapActions } from "vuex";
import NoPermissionComponent from "@/components/NoPermissionComponent.vue";


export default {
  name: "PowerBISelectView",
  components: {
    NoPermissionComponent,

  },
  props: {
    site: { type: String, required: false },
  },
  data() {
    return {
        chosen_site: this.site
    }
  },

  methods: {
    ...mapGetters(["getUsername", "isLoggedIn", "getServiceSitesAndSeu",
                  "getLoader", "getFormError","getPowerBIDashboards", "getSiteNames","getMeterHealthCheckList"]),
    ...mapActions(["performSetFormError", "fetchPowerBIDashboards", "fetchMeterHealthCheckList"]),
    setSite(selected_site) {
      this.chosen_site = selected_site
    },
    gotToPowerBIDashboard(id, e) {
      const url = `/power-bi/powerbi/${id}`;

      // Ctrl (Windows/Linux), Meta (Cmd on macOS), or middle-click
      const openInNewTab = e.ctrlKey || e.metaKey || e.button === 1;

      if (openInNewTab) {
        window.open(url, '_blank', 'noopener,noreferrer');
      } else {
        window.location.assign(url);
      }
    },
    goToPowerBIStandardSearch() {
      location.href=(`/powerbi-select/All`);
    },
    goToPowerBISelectSearch() {
      location.href=(`/power-bi/powerbi-dashboards`);
    },    gotToMeterHealthCheckDashboard(site) {
        const url = `/meter-health-check/${site}`;
        window.location.assign(url);
    },
    gotToEnergyEyeDashboard(site) {
        const url = `/energy-eye/${site}`;
        window.location.assign(url);
    },
    splitString(string) {
      const parts = string.split('[');
      const name = parts[0].trim();
      const site_code = '[' + parts[1].trim();
      return [name, site_code];
    },
    extractSiteCode(str) {
      const start = str.indexOf('[');
      const end = str.indexOf(']');
      return str.substring(start + 1, end);
    },

  },

  created() {
    document.title = "SEU Dashboards";
    this.performSetFormError(null);
    this.fetchMeterHealthCheckList();
    this.fetchPowerBIDashboards();
    window.scrollTo(0,0);
  }
}


</script>
<style scoped>
.expanded {
  cursor: pointer;
}
.expanded:hover {
  text-decoration: underline;
}
</style>